import { Injectable, inject } from '@angular/core';
import { MerchandiseService } from '@epicuro-next/data/merchandise';
import { ComponentStore } from '@ngrx/component-store';
import { map, switchMap, tap } from 'rxjs';
import { IAuthMedia } from '../models/auth-media.interface';
import { Store } from '@ngrx/store';
import {
  getCurrentLanguage,
  languageActions,
  selectAvailableLanguages,
  selectLanguage,
} from '@epicuro-next/platform/i18n';

interface IAuthState {
  merchandise: IAuthMedia;
}

@Injectable()
export class AuthComponentStore extends ComponentStore<IAuthState> {
  private merchandiseService = inject(MerchandiseService);
  private store = inject(Store);

  public merchandise$ = this.select((state) => state.merchandise);
  public availableLanguages$ = this.store
    .select(selectAvailableLanguages)
    .pipe(map((value) => value ?? getCurrentLanguage()));
  public selectedLanguage$ = this.store
    .select(selectLanguage)
    .pipe(map((value) => value ?? []));

  constructor() {
    super({
      merchandise: {},
    });

    this.fetchLoginBgMerchandise();
  }

  private fetchLoginBgMerchandise = this.effect<void>((void$) => {
    return void$.pipe(
      switchMap(() => {
        return this.merchandiseService.getLoginBackground();
      }),
      map((response) => {
        return this.merchandiseService.parseResponse(response) as IAuthMedia;
      }),
      tap((response: IAuthMedia) => {
        this.patchState({
          merchandise: response ?? {},
        });
      }),
    );
  });

  public setLanguage(id: string) {
    this.store.dispatch(languageActions.setLoginLanguage({ selected: id }));
  }
}
